import { jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
/**
 * PageFilterLink is a text-style filter button used in toolbars.
 * Active state shows bold text with underline, inactive shows muted text.
 *
 * @example
 * <PageToolbar.Filters>
 *   <PageFilterLink active={filter === 'active'} count={5} onClick={() => setFilter('active')}>
 *     Active
 *   </PageFilterLink>
 *   <PageFilterLink active={filter === 'archived'} count={2} onClick={() => setFilter('archived')}>
 *     Archived
 *   </PageFilterLink>
 * </PageToolbar.Filters>
 */ export function PageFilterLink({ active, count, onClick, children, className }) {
    return /*#__PURE__*/ _jsxs("button", {
        type: "button",
        onClick: onClick,
        className: cn('transition-colors', active ? 'font-bold text-gray-900 underline underline-offset-4' : 'text-gray-500 hover:text-gray-700', className),
        children: [
            children,
            count !== undefined && ` (${count})`
        ]
    });
}
